module.exports = __webpack_public_path__ + "static/img/pupil-plate.d3db859.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/canteen/pupil-plate.svg
// module id = 154
// module chunks = 2